import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	label: {
		id: 'navigation.global-shortcuts.apps.company-hub',
		defaultMessage: 'Company Hub',
		description: 'The link label for Company Hub',
	},
});
